/*
 * Public API Surface of shared-lib
 */

export * from './lib/shared-lib.service';

// Services
export * from './lib/services/responsive.service';
export * from './lib/services/navigation.service';
export * from './lib/services/language.service';
export * from './lib/services/app-locale';

// Components
export * from './lib/components/vertical-nav/vertical-nav.component';
export * from './lib/components/vertical-nav/vertical-nav-item/vertical-nav-item.component';
export * from './lib/components/app-layout/app-layout.component';
export * from './lib/components/language-switcher/language-switcher.component';

// UI Components
export * from './lib/components/ui/button/button.component';
export * from './lib/components/ui/badge/badge.component';
export * from './lib/components/ui/alert/alert.component';
export * from './lib/components/ui/card/card.component';
export * from './lib/components/ui/input/input.component';
export * from './lib/components/ui/modal/modal.component';
export * from './lib/components/ui/dropdown/dropdown.component';
export * from './lib/components/ui/autocomplete-create/autocomplete-create.component';
export * from './lib/components/ui/loading/loading.component';
export * from './lib/components/ui/table/table.component';
export * from './lib/components/ui/calendar/calendar.component';
export * from './lib/components/ui/jjames-paginator/jjames-paginator.component';
export * from './lib/components/ui/image-container/image-container.component';

// Charts
export * from './lib/components/ui/charts/timeline-chart/timeline-chart.component';
export * from './lib/components/ui/charts/gauge-chart/gauge-chart.component';

// Responsive Component
export * from './lib/components/responsive/responsive';

// License plate rendering. Lives here rather than in one app because the same plate has to be
// drawn by the parker webshop, the operator dashboard and the entry/exit/payment displays — and
// the display Pis have to draw it with no uplink, so the emblems ship in the bundle, not from the
// API. See at-coat-of-arms.ts for why the arms are not stored in the database.
export * from './lib/components/plate/plate.component';
export * from './lib/components/plate/plate-countries';
export * from './lib/components/plate/plate-emblems';
export * from './lib/components/plate/AT/at-districts';
export * from './lib/components/plate/AT/at-arms';

// Types
export * from './lib/types/ui.types';
export * from './lib/types/role.enum';
export * from './lib/types/countries';

// Utils
export * from './lib/utils/class-utils';
export * from './lib/utils/date-utils';
export * from './lib/utils/api-error';
export * from './lib/utils/print-receipt';

// Interceptors
export * from './lib/interceptors/unauthorized.interceptor';